import { keyframes } from "styled-components";

export const moveInLeft = keyframes`
  from {
    opacity: 0.2;
    transform : translateX(-30px)
  }
  to {
    opacity: 1;
    transform : translateX(0)
  }
`;
